/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const findFaqByLanguageResponseDtoCategoryEnum = {
  DASHBOARD: "DASHBOARD",
  PRODUCTS: "PRODUCTS",
  SUPPLIERS: "SUPPLIERS",
  CERTIFICATES: "CERTIFICATES",
  DATA_TRANSFER: "DATA_TRANSFER",
  OTHER: "OTHER",
} as const

export type FindFaqByLanguageResponseDtoCategoryEnumKey =
  (typeof findFaqByLanguageResponseDtoCategoryEnum)[keyof typeof findFaqByLanguageResponseDtoCategoryEnum]

export const findFaqByLanguageResponseDtoLangEnum = {
  FR: "FR",
  EN: "EN",
  ZH: "ZH",
  PT: "PT",
  IT: "IT",
  ES: "ES",
  TR: "TR",
  DE: "DE",
  NL: "NL",
  AR: "AR",
  KO: "KO",
  JA: "JA",
  BE: "BE",
  RO: "RO",
  LT: "LT",
} as const

export type FindFaqByLanguageResponseDtoLangEnumKey =
  (typeof findFaqByLanguageResponseDtoLangEnum)[keyof typeof findFaqByLanguageResponseDtoLangEnum]

export type FindFaqByLanguageResponseDto = {
  /**
   * @description FAQ ID
   * @type string
   */
  id: string
  /**
   * @description Question
   * @type string
   */
  question: string
  /**
   * @description Answer
   * @type string
   */
  answer: string
  /**
   * @description Category
   * @type string
   */
  category: FindFaqByLanguageResponseDtoCategoryEnumKey
  /**
   * @description Language
   * @type string
   */
  lang: FindFaqByLanguageResponseDtoLangEnumKey
  /**
   * @description Created at
   * @type string, date-time
   */
  createdAt: Date
  /**
   * @description Updated at
   * @type string, date-time
   */
  updatedAt: Date
}
